// apps/web/src/app/store/jagaAturan.ts
/**
 * When leaving asks "Tinggalkan tanpa menyimpan?" (spec 2026-09-30-sapuan-isian, 3.8),
 * without React: a navigation is held while any form holds unsaved changes, unless a save or
 * an explicit Batal has just let the next one through, and never for a move that stays at the
 * same address. The move to the sign-in screens once the session has closed is not held
 * either: it follows a sign-out the person already confirmed (Pengaturan's Keluar) or a lock,
 * and the shell does not survive it, so there is nothing to go back to. A move to them while
 * the session is still open (Akun's "Masuk lagi", a link to a sign-in step) is a move like any
 * other: it asks.
 */
export interface Lokasi {
  pathname: string
  search: string
}

export interface KeadaanJaga {
  /** Forms with unsaved changes. */
  jumlahAktif: number
  /** Until this instant (ms) the next navigation passes. */
  lewatiSampai: number
  /** The session is open (`aktif`): not signed out, not locked. */
  sesiTerbuka: boolean
}

export const LEWATI_MS = 3000

function keMasuk(ke: Lokasi): boolean {
  return ke.pathname === '/masuk' || ke.pathname.startsWith('/masuk/')
}

export function harusTanya(k: KeadaanJaga, sekarang: number, dari: Lokasi, ke: Lokasi): boolean {
  if (dari.pathname === ke.pathname && dari.search === ke.search) return false
  if (k.jumlahAktif === 0) return false
  if (keMasuk(ke) && !k.sesiTerbuka) return false
  return sekarang >= k.lewatiSampai
}
